module.exports = __webpack_public_path__ + "static/media/portfolio.6e7dc5ad.gif";